import CustomTooltip from '@/DesignSystem/components/tooltip/CustomTooltip';
import CustomImageComponent from '../custom/custom-image';
import Link from 'next/link';
import { Rutas } from '@/constants/rutas';

export const DonquiLogo = ({ width, height }) => {
    const src = `${process.env.NEXT_PUBLIC_IMAGES}/logos/donquijote.jpg?width=${width * 1.5}`;

    return (
        <Link href={Rutas.LA_PIZARRA_DE_DONQUI} prefetch={false}>
            <CustomTooltip label="Don Quijote De La Cancha">
                <CustomImageComponent
                    src={src}
                    alt="Don Quijote De La Cancha"
                    width={width}
                    height={height ?? width}
                    style={{ borderRadius: '50%', cursor: 'pointer' }}
                />
            </CustomTooltip>
        </Link>
    );
};

const DonquijoteLogo = ({ width, height }) => {
    const src = `${process.env.NEXT_PUBLIC_IMAGES}/logos/donquijote.jpg?width=${width * 1.5}`;

    return (
        <CustomTooltip label="Don Quijote De La Cancha">
            <CustomImageComponent
                src={src}
                alt="Don Quijote De La Cancha"
                width={width}
                height={height ?? width}
                style={{ borderRadius: '50%', cursor: 'pointer' }}
            />
        </CustomTooltip>
    );
};

export default DonquijoteLogo;
